import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { z } from "zod";
import { IntegrationForm } from "../integration-form";

const controlCode = ControlCodes.TENABLE;
const controlName = getControlName(controlCode);

export const TenableIntegrationForm = ({
  instance,
}: {
  instance?: Control;
}) => (
  <IntegrationForm
    control={controlCode}
    instanceId={instance?.instance_id}
    instanceName={instance?.name ?? undefined}
    description={`Connect to ${controlName}, and evaluate the vulnerability of your endpoints.`}
    fields={{
      accessKey: {
        label: "Access Key",
        placeholder: "Enter your Access Key",
        defaultValue: instance?.username,
        required: true,
        validator: z.string().nonempty(),
      },
      secretKey: {
        label: "Secret Key",
        type: "password",
        placeholder: "Enter your Secret Key",
        required: true,
        validator: z.string().nonempty(),
      },
    }}
    transformParams={({ accessKey, secretKey }) => ({
      api: "https://cloud.tenable.com",
      user: accessKey,
      secret: secretKey,
    })}
  />
);
